<template>
  <v-container class="pa-0">
    <h4>How would you like your phone calls answered?</h4>
    <v-radio-group required dense v-model="answer">
      <v-radio dense :value="first_option" :label="first_option"></v-radio>
      <v-radio dense :value="second_option" :label="second_option"></v-radio>
      <v-radio dense :value="third_option" :label="third_option"></v-radio>
    </v-radio-group>
    <v-textarea maxlength="150" counter v-model="custom_phone_message" solo dense v-show="answer === third_option" :rows="4" auto-group></v-textarea>
  </v-container>
</template>

<script>
  import {mapState} from 'vuex';
  export default {
    name: 'PhoneAnswering',
    computed: {
      ...mapState('company_details', {
        first_option: state => ['Thank you for calling', state.company_name + ',', 'how can I help you?'].join(' '),
        second_option: state => ['Welcome to', state.company_name + ',','how can I direct your call?'].join(' '),
      }),
      third_option: () => "Other answer:",
      answer: {
        get() {
          if(this.$store.state.additional_services.phone_answering_selection) {
            // Option already exists. Don't default.
            return this.$store.state.additional_services.phone_answering_selection;
          } else {
            // Set default option here
            this.$store.commit('additional_services/setPhoneSelection', this.first_option);
            return this.first_option;
          }
        },
        set(value) {
          this.$store.commit('additional_services/setPhoneSelection', value);
        },
      },
      custom_phone_message: {
        get() {
          return this.$store.state.additional_services.custom_phone_message;
        },
        set(value) {
          this.$store.commit('additional_services/setCustomPhoneMessage', value)
        },
      },
    }
  }
</script>
<style scoped>
</style>
